import { getStorageValue, removeStorageValue, setStorageValue } from '@portal-internet/core';
import moment from 'moment';

const LayoutChangesTmpStorageService = {
    _prefix: 'ccma_webapp_',
    storageKey: 'layoutChanges',

    _generateKey(user_id) {
        return `${this._prefix}${user_id}_${this.storageKey}`;
    },

    /**
     * Retrieve layout data and creation date.
     * - If no user_id → shared layout
     * - If no pathname → all layout data for the user
     * - If pathname → only that layout data
     */
    get(user_id, pathname, layout) {
        const key = this._generateKey(user_id);
        const raw = localStorage.getItem(key);
        if (!raw) return;

        const { data } = JSON.parse(raw || '{}');
        return {
            data : data?.[pathname]?.[layout].layout, 
            creationDate: data?.[pathname]?.[layout].creationDate 
        };
    },

    save(user_id, pathname, layout, layoutState) {
        if (!user_id) return;
        const key = this._generateKey(user_id);
        const existing = JSON.parse(localStorage.getItem(key) || '{}');

        const data = existing?.data || existing || {};

        const updated = {
            ...data,
            [pathname]: {
                ...(data[pathname] || {}),
                [layout]: {
                    layout : layoutState[pathname],
                    creationDate : new Date().getTime()
                }
            }
        }
        setStorageValue(key, updated, { expires: Infinity });
    },

    /**
     * Clear layout data.
     * Throws if no data exists for this user.
     * If pathname provided, removes only that layout.
     * Otherwise, clears all layout data.
     */
    clear(user_id, pathname, layout) {
        const key = this._generateKey(user_id);
        const raw = localStorage.getItem(key);
        if (!raw) return;

        if (!pathname || !layout) {
            removeStorageValue(key);
            return;
        }

        let existing = JSON.parse(raw || '{}');
        if (!existing?.data?.[pathname]?.[layout]) {
            return;
        }

        delete existing.data[pathname][layout];
        if (!existing.data[pathname] || Object.keys(existing.data[pathname]).length === 0) {
            delete existing.data[pathname];
        }
        if (!existing.data || Object.keys(existing.data).length === 0) {
            removeStorageValue(key);
        } else {
            setStorageValue(key, existing?.data, { expires: Infinity });
        }
    },

    /**
     * Checks if layout changes exist for the user.
     * Returns false if no data or if the layout is empty.
     * If pathname provided, checks only that layout.
     */
    exists(user_id, pathname, layout) {
        const key = this._generateKey(user_id);
        const raw = localStorage.getItem(key);
        if (!raw) return false;

        try {
            const value = JSON.parse(raw || '{}');
            if(moment().diff(value?.creationDate, 'minutes') > 3) return false;
            return !!value?.data?.[pathname]?.[layout] && Object.keys(value.data[pathname][layout]).length > 0;
        } catch {
            return raw.trim() !== '';
        }
    }
};

export default LayoutChangesTmpStorageService;
